import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { WhatYouGet } from '../components/WhatYouGet';
import { Comparison } from '../components/Comparison';
import { Note } from '../components/Note';
import { AboutAuthor } from '../components/AboutAuthor';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { OfferBlock } from '../components/OfferBlock';
import { Footer } from '../components/Footer';
export const Home = () => {
  return <div className="min-h-screen bg-dark text-gray-300 font-sans selection:bg-neon selection:text-black overflow-x-hidden" data-id="element-360">
      <UrgencyBar data-id="element-361" />
      {/* Spacer for fixed urgency bar */}
      <div className="h-10 sm:h-11" aria-hidden="true" data-id="element-362" />

      <Hero data-id="element-363" />
      <Services data-id="element-364" />
      <WhatYouGet data-id="element-365" />
      <Comparison data-id="element-366" />
      <Note data-id="element-367" />
      <AboutAuthor data-id="element-368" />
      <Guarantee data-id="element-369" />
      <FAQ data-id="element-370" />
      <OfferBlock data-id="element-371" />
      <Footer data-id="element-372" />
    </div>;
};